import $ from 'jquery';
import tdaConfig from 'lib/util/tda.config';
import paramByName from 'lib/getParameterByName';
import zip from 'lib/util/zip';
import zipTools from 'components/zip-tools';
import cookies from 'utils/cookies';
import PageCache from 'lib/page-cache';
import rtiCheck from 'lib/gxp/dealers.rti.check';
import dealerSearchModal from 'features/ctas/dealer.search.modal';
import storageUtil from 'utils/storage-util';
import setDgConfig from './setDgConfig';
import rtiDealerCode from './rtiDealerCode';
import entryPoints from './entryPoints';

var __cookieName = 'dealer_code_rti_code';
var __oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
var __thisHref = `/${tdaConfig.site.context_url}/inventory/results/?series=${paramByName('series', window.location.href)}`;

// ! test and localhost to __int for preprod testing
var __int = ['preview', 'national-preview', 'staging', 'national-staging'];
var __stage = ['localhost', 'test'];
var __dev = ['national-dev'];

function __getEnviron() {
  var parts = window.location.hostname.split('.');
  var subdomain = parts.shift();

  if (__int.includes(subdomain)) {
    return 'int';
  }
  if (__stage.includes(subdomain)) {
    return 'stage';
  }
  if (__dev.includes(subdomain)) {
    return 'dev';
  }
  return 'prod';
}

function __dgCDN() {
  // return vals match that found in fixed-layout in LSDS
  var env = __getEnviron();
  if (env === 'int') return 'https://cdn.dgint.deops.toyota.com';
  if (env === 'stage') return 'https://cdn.dgstage.deops.toyota.com';
  if (env === 'dev') return 'https://cdn.dgdev.deops.toyota.com';
  return 'https://cdn.dg.toyota.com';
}

function __gxpUrl(href) {
  var qs = $.param({
    series: paramByName('series', href),
    dealerCd: rtiDealerCode.savedDealerCode(),
    zipcode: zip.getCookiedDefaultFallback(),
  });
  return `/${tdaConfig.site.context_url}/inventory/search/?${qs}`;
}

var __ctaLookAlike = {
  // invoked directly OR from within modal
  dealerSelect: function (e, selectedDealer, newZip) {
    e && e.preventDefault();
    var rtiDealer = selectedDealer.isRti;
    console.log('%c __ctaLookAlike:', 'background: green; color: white');
    console.log('selected dealer: ', selectedDealer);
    cookies.setItem(
      __cookieName,
      String(rtiDealer ? selectedDealer.dealerCode : 'false'), // cookie val is false or the dealerCode of rti participant
      __oneYear,
      '/',
      zipTools.getCrossDomainCookieDomain()
    );
    storageUtil.setConfirmedZip(true);
    storageUtil.setZip(newZip || selectedDealer.zipCode); // ideall set zip to user used NOT dealer based
    if (rtiDealer) {
      window.DGDataHub.changeActiveDealer(selectedDealer.dealerCd);
      setDgConfig();
      if (entryPoints.isBatEntry || entryPoints.isGxpEntry) {
        window.location.href = __gxpUrl(window.location.href);
      }
    } else {
      window.DGDataHub.changeActiveDealer('Toyota');
      window.location.href = __thisHref;
    }
  }
};
Object.setPrototypeOf(__ctaLookAlike, dealerSearchModal);

var garage = {
  // invoked via footer.js gxpLoad func, on GXP participants only
  init: function () {
    window.DGDataHub = { Deploy_Env: __getEnviron(), DEPLOY_ENV: __getEnviron() };
    setDgConfig();
    this.changeZipListen();
    this.getDgScripts();
  },

  changeZipListen: function () {
    // this should be the ONLY thing we still have to do in zip tools change Zip func
    PageCache.on('ZIP_CODE_RTI_FLOW_ENTER', function (changeZipData) {
      var temp = new Date();
      temp.setSeconds(temp.getSeconds() + 30);
      cookies.setItem('dealer_gxp_changing', String(true), temp, '/', zipTools.getCrossDomainCookieDomain());
      var finalCb = function () {
        cookies.removeItem(__cookieName, '/', zipTools.getCrossDomainCookieDomain());
        cookies.removeItem('dealer_gxp_changing', '/', zipTools.getCrossDomainCookieDomain());
        // check dealers against this new zip
        /* console.log('%c all done with zip change, now what?:', 'background: green; color: white');
        console.log('changeZipData', changeZipData); */

        if (entryPoints.isGxpEntry || entryPoints.isBatEntry) {
          // if on rti entry point, or BAT entry point
          // get dealers and do it all again
          rtiCheck(changeZipData.newZip)
            .then((pmaRes) => {
              if (!pmaRes) {
                window.location.href = __thisHref;
              } else if (pmaRes.length === 1) {
                __ctaLookAlike.dealerSelect(null, pmaRes[0], changeZipData.newZip);
              } else {
                __ctaLookAlike.setMode('pma');
                __ctaLookAlike.beginSearch(changeZipData.newZip);
              }
            })
            .catch(err => console.log('err: ', err));
        } else {
          // if on non-entry point page, no need to check, just changeActiveDealer to 'toyota'
          window.DGDataHub.changeActiveDealer('Toyota');
          setDgConfig();
        }
      };
      var gxpChangeContinue = function () {
        console.log('GXP user elected to change zip.');
        zipTools.changeZip(
          changeZipData.currentZip,
          changeZipData.newZip,
          null,
          finalCb,
          false,
          false,
          false
        );
      };
      var gxpChangeCancel = () => {
        console.log('GXP user didnt change. Do nothing.');
        zipTools.updateZipFields(changeZipData.currentZip);
        cookies.removeItem('dealer_gxp_changing', '/', zipTools.getCrossDomainCookieDomain());
      };
      // Show GXPs 'Dealer Change' warning, providing continue and cancel callbacks
      window.DGDataHub.showDealerWarning(gxpChangeContinue, gxpChangeCancel);
    });
  },

  getDgScripts: function () {
    var savesPage = window.location.href.indexOf('/saves/') > -1;
    var offersIframe = window.location.href.indexOf('/dealer_offers_frame/') > -1;
    if (offersIframe) { return; } // don't display garage if on offers iframe
    var script = '/deploy/dg-library/latest/deploy/dg-app.min.js';
    if (savesPage) {
      script = '/deploy/dg-pages/1-0/dg-spas-main.min.js';
    }

    $.ajax({
      url: `${__dgCDN()}${script}`,
      dataType: 'script',
      cache: true
    }).done(function () {

    }).fail(function (data) {
      console.error('error: ', data);
    });

    $.ajax({
      url: `${__dgCDN()}/deploy/dg-components/1-0/dg-component-main.min.js`,
      dataType: 'script',
      cache: true
    }).done(function () {

    }).fail(function (data) {
      console.error('error: ', data);
    });

    // Once dg-loader is good to go, we can drop the above, and remove the entire ws-app.min.js bit from LSDS
    // However, the saves page does NOT use the loader. note: does that mean the saves page doesn't need ws-app.min.js?
    /*
    if (savesPage) {
      $.ajax({
        url: __dgCDN() + '/deploy/dg-pages/1-0/dg-spas-main.min.js',
        dataType: 'script',
        cache: true
      }).done(function () {

      }).fail(function (data) {
        console.log('error: ', data);
      });

      $.ajax({
        url: __dgCDN() + '/deploy/dg-components/1-0/dg-component-main.min.js',
        dataType: 'script',
        cache: true
      }).done(function () {

      }).fail(function (data) {
        console.log('error: ', data);
      });
    } else {
      // New way!
      $.ajax({
        url: `${__dgCDN()}/deploy/dg-loader/latest/dg-loader-app.min.js`,
        dataType: 'script',
        cache: true,
      })
        .done(() => console.log('loaded DG-loader'))
        .fail(err => console.log('err loading dg-loader: ', err));
    }
    */
  }
};

export default garage;
